import { createRoute } from '@tanstack/react-router'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Settings/Setups'
import { mediaPlatformSettingsLayoutRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings'

export const mediaPlatformSettingsSetupsRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsLayoutRoute,
  path: StaticRouteParameter.SETUPS,
  loader: () => null,
})

export const mediaPlatformSettingsSetupsOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsSetupsRoute,
  path: '/',
  component: Overview,
})
